import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Router } from '@angular/router';
import 'rxjs/add/observable/throw';
import { Observable } from 'rxjs/Observable';
import { BaseLoopBackStorageService as StorageService } from '../storage/loopback/base.service';
import { SwalErrorHandler } from '../../shared/constants';

declare const swal: any;

@Injectable()
export class BaseErrorService {

  constructor(
    private router: Router,
    private storageService: StorageService
  ) { }

  static parseErrorMessage(error: any): any {
    const msg = [];
    const messages = (error && typeof error.message !== 'undefined') ? error.message : [];
    if (typeof messages === 'string') {
      return messages;
    }
    const keys = Object.keys(messages);
    for (const key of keys) {
      for (const elem of messages[key]) {
        if (elem.message) {
          msg.push(key + ': ' + elem.message);
        }
      }
    }
    return msg;
  }

  /**
   * @description Handle error response function
   * @param {Response} response
   * @return {any}
   */
  public handleError(response: any): any {
    let message = response.error.error.message || response.error.error.errmsg || BaseErrorService.parseErrorMessage(response.error.error);
    switch (response.status) {
      case 400:
        // Bad Request
        console.log('Bad Request: ', response);
      break;
      case 401:
        // Unauthorized
        console.log('Forbidden access: ', response);
        this.storageService.clear();
        this.router.navigate(['/login']);
      break;
      case 422:
        // Unprocessable Entity
        console.log('Unprocessable Entity: ', response);
      break;
      case 500:
        // Internal Server Error
        console.log('Internal server error: ', response);
        if (message === 'Can not get accessToken') {
          this.storageService.clear();
          this.router.navigate(['/login']);
        }
        if (message.indexOf('duplicate') !== -1) {
          message = 'Duplicate code, please try again.';
        }
      break;
      case 502:
        console.log('Bad Gateway', response);
      break;
      default:
        // Unknown error
        console.log('Unknown error: ', response);
      break;
    }
    return Observable.throw(message);
  }

  static errorMessage(error) {
    return {title: 'Error!', text: error, type: 'error'};
  }
  static successMessage(success, param?: any) {
    return {title: 'Successfully!', text: success + param, type: 'success'};
  }
  static warningMessage(warning) {
    return {title: 'Warning!', text: warning, type: 'warning'};
  }
}



// WEBPACK FOOTER //
// ./src/app/services/error/base.service.ts